import "../style/employeList.css";
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE = 5;

export default function EmployeeListing() {
  const navigate = useNavigate();

  /* ================= STATE ================= */
  const [employees, setEmployees] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);
  const [selected, setSelected] = useState([]);
  const [sort, setSort] = useState({ key: "", order: "asc" });
  const [page, setPage] = useState(1);

  const [filters, setFilters] = useState({
    name: "",
    id: "",
    employeeType: "",
    status: "",
    // jobTitle: "",
    subUnit: "",
  });

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("employees")) || [];
    setEmployees(data);
    setAllEmployees(data);
  }, []);

  /* ================= FILTER HANDLERS ================= */
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    let filtered = [...allEmployees];

    if (filters.name) {
      filtered = filtered.filter((emp) =>
        emp.name.toLowerCase().includes(filters.name.toLowerCase()),
      );
    }

    if (filters.id) {
      filtered = filtered.filter((emp) =>
        emp.id.toString().includes(filters.id),
      );
    }

    if (filters.employeeType) {
      filtered = filtered.filter((emp) => emp.job === filters.employeeType);
    }

    if (filters.status) {
      filtered = filtered.filter((emp) => emp.status === filters.status);
    }

    setEmployees(filtered);
    setPage(1);
    setSelected([]);
  };

  const handleReset = () => {
    setFilters({
      name: "",
      id: "",
      employeeType: "",
      status: "",
    });
    setEmployees(allEmployees);
    setPage(1);
    setSelected([]);
  };

  /* ================= CHECKBOX ================= */
  const toggleSelectAll = (e) => {
    setSelected(e.target.checked ? employees.map((e) => e.id) : []);
  };

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  /* ================= BULK DELETE ================= */
  const bulkDelete = () => {
    if (!selected.length) return alert("No employees selected");
    if (!window.confirm("Delete selected employees?")) return;

    const updated = allEmployees.filter((emp) => !selected.includes(emp.id));
    setEmployees(updated);
    setAllEmployees(updated);
    setSelected([]);
    localStorage.setItem("employees", JSON.stringify(updated));
  };

  /* ================= SORT ================= */
  const handleSort = (key) => {
    const order = sort.key === key && sort.order === "asc" ? "desc" : "asc";
    setSort({ key, order });

    const sorted = [...employees].sort((a, b) => {
      if (a[key] < b[key]) return order === "asc" ? -1 : 1;
      if (a[key] > b[key]) return order === "asc" ? 1 : -1;
      return 0;
    });

    setEmployees(sorted);
  };

  /* ================= PAGINATION ================= */
  const start = (page - 1) * ITEMS_PER_PAGE;
  const paginated = employees.slice(start, start + ITEMS_PER_PAGE);
  const totalPages = Math.ceil(employees.length / ITEMS_PER_PAGE);

  /* ================= ACTIONS ================= */
  const deleteOne = (id) => {
    if (!window.confirm("Delete employee?")) return;
    const updated = allEmployees.filter((emp) => emp.id !== id);
    setEmployees(updated);
    setAllEmployees(updated);
    localStorage.setItem("employees", JSON.stringify(updated));
  };

  const editEmployee = (emp) => {
    navigate("/add-employee", { state: emp });
  };

  /* ================= UI ================= */
  return (
  

<div className="app-layout">
{/* Side bar */}
  <aside className="sidebar">
      {/* ===== LOGO ===== */}
      {/* <div className="sidebar-logo">
        <img src={logo} alt="OrangeHRM" />
      </div> */}

      {/* ===== MENU ===== */}
      <ul className="employee-menu">
        <li>
          <NavLink to="/search" className="menu-item">
            <span className="icon">🔍</span>
            <span>Search</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/admin" className="menu-item">
            <span className="icon">👤</span>
            <span>Admin</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employee-list"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <span className="icon">👥</span>
            <span>PIM</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/leave-list" className="menu-item">
            <span className="icon">📝</span>
            <span>Leave</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/time" className="menu-item">
            <span className="icon">⏱</span>
            <span>Time</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/recruitment" className="menu-item">
            <span className="icon">🎯</span>
            <span>Recruitment</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/my-info" className="menu-item">
            <span className="icon">📄</span>
            <span>My Info</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/performance" className="menu-item">
            <span className="icon">⭐</span>
            <span>Performance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/dashboard" className="menu-item">
            <span className="icon">🏠</span>
            <span>Dashboard</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/directory" className="menu-item">
            <span className="icon">📇</span>
            <span>Directory</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/maintenance" className="menu-item">
            <span className="icon">⚙️</span>
            <span>Maintenance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/claim" className="menu-item">
            <span className="icon">💰</span>
            <span>Claim</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/buzz" className="menu-item">
            <span className="icon">💬</span>
            <span>Buzz</span>
          </NavLink>
        </li>
      </ul>
    </aside>



      {/* ===== Stats ===== */}
      <main className="main-content">
          <div className="dashboard-page">
      <div className="dashboard-stats">
        <div className="stat-card">
          <span>Total Employees</span>
          <strong>{employees.length}</strong>
        </div>
        <div className="stat-card">
          <span>On Leave Today</span>
          <strong>5</strong>
        </div>
        <div className="stat-card">
          <span>Pending Requests</span>
          <strong>3</strong>
        </div>
      </div>

      {/* ===== Filter Section ===== */}
      <div className="oxd-table-filter">
        <div className="filter-header">
          <h5>Employee Information</h5>
        </div>

        <div className="oxd-grid-4">
          <div className="form-group">
            <label htmlFor="employee name">Employee Name</label>

            <input
              name="name"
              placeholder="Employee Name"
              value={filters.name}
              onChange={handleFilterChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="employee id">Employee ID</label>
            <input
              name="id"
              placeholder="Employee Id"
              value={filters.id}
              onChange={handleFilterChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="employee type">Employee Type</label>
            <select
              name="employeeType"
              value={filters.employeeType}
              onChange={handleFilterChange}
            >
              <option value="">-- Select -- </option>
              <option value="Full Time">Full Time</option>
              <option value="Part Time">Part Time</option>
              <option value="Contract">Contract</option>
              <option value="Freelance">Freelance</option>
              <option value="Full-Time Contract">Full-Time Contract</option>
              <option value="Full-Time Probation">Full-Time Probation</option>
              <option value="Part-Time Contract">Part-Time Contract</option>
              <option value="Part-Time Internship">Part-Time Internship</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="include">Include</label>
            <select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">Select Employees</option>
              <option value="Active">Current Employees Only</option>
              <option value="Active And Inactive">
                Current and Past Employees
              </option>
              <option value="Inactive">Past Employees Only</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="Supervisor Name">Supervisor Name</label>
            <input
              name="Supervisor Name"
              placeholder="Supervisor Name"
              value={filters.name}
              onChange={handleFilterChange}
            />
          </div>

<div className="form-group">

 <label htmlFor=" job title">Job Title</label>
          <select
            name="job-title"
            value={filters.jobTitle}
            onChange={handleFilterChange}
          >
            <option value="">-- Select --</option>

            <option value="Account Assistant">Account Assistant</option>
            <option value="admin">admin</option>
            <option value="Automaton Tester">Automaton Tester</option>
            <option value="Chief Executive Officer">
              Chief Executive Officer
            </option>
            <option value="Chief Financial Officer">
              Chief Financial Officer
            </option>
            <option value="Customer Success Manager">
              Customer Success Manager
            </option>
            <option value="Database Administrator">
              Database Administrator
            </option>
            <option value="Finance Manager">Finance Manager</option>
            <option value="Content Specialist">Content Specialist</option>
            <option value="Chief Technical Officer">
              Chief Technical Officer
            </option>
            <option value="QA Lead">QA Lead</option>
            <option value="QA Engineer">QA Engineer</option>
            <option value="Pre-Sales Coordinator">Pre-Sales Coordinator</option>
            <option value="Payroll Administrator">Payroll Administrator</option>
            <option value="Network Administrator">Network Administrator</option>
            <option value="IT Manager">IT Manager</option>
            <option value="HR Manager">HR Manager</option>
            <option value="HR Associate">HR Associate</option>
            <option value="Head of Support">Head of Support</option>
            <option value="Financial Analyst">Financial Analyst</option>
            <option value="VP - Sales & Marketing">
              VP - Sales & Marketing
            </option>
            <option value="VP - Client Services">VP - Client Services</option>
            <option value="Support Specialist">Support Specialist</option>
            <option value="Software Engineer">Software Engineer</option>
            <option value="Software Architect">Software Architect</option>
            <option value="Social Media Marketer">Social Media Marketer</option>
            <option value="Sales Representative">Sales Representative</option>
          </select>
</div>

<div className="form-group">
 
 <label htmlFor="department">Department</label>

          <select
            name="department"
            value={filters.department}
            onChange={handleFilterChange}
          >
            <option value="">-- Select --</option>
            <option value="Administration">Administration</option>
            <option value="Engineering">Engineering</option>
            <option value="Development">Development</option>
            <option value="Quality Assurance">Quality Assurance</option>
            <option value="TechOps">TechOps</option>
            <option value="Sales & Marketing">Sales & Marketing</option>
            <option value="Sales">Sales</option>
            <option value="Marketing">Marketing</option>
            <option value="Client Services">Client Services</option>
            <option value="Technical Support">Technical Support</option>
            <option value="Finance">Finance</option>
            <option value="Human Resources">Human Resources</option>
          </select>

          </div>
        </div>

        <div className="oxd-form-actions">
          <button
            className="oxd-button oxd-button--ghost"
            onClick={handleReset}
          >
            Reset
          </button>
          <button
            className="oxd-button oxd-button--secondary"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>
      </div>

      {/* ===== ACTION HEADER ===== */}
      <div className="oxd-form-actions-add">
        <button className="oxd-button oxd-button--secondary">
          <NavLink className="add-employee" to="/add-employee">+ Add Employee</NavLink>
        </button>
        <button className="oxd-button oxd-button--ghost" onClick={bulkDelete}>
          Delete Selected
        </button>
      </div>
      <br />
     

      {/* ===== TABLE ===== */}
      <div className="table-wrapper modern-table">
        <table>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    selected.length === employees.length && employees.length > 0
                  }
                />
              </th>
              <th onClick={() => handleSort("id")}>Id ↑↓</th>
              <th onClick={() => handleSort("name")}>Name ↑↓</th>
              <th onClick={() => handleSort("job")}>Job ↑↓</th>
              <th onClick={() => handleSort("status")}>Status ↑↓</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {paginated.length ? (
              paginated.map((emp) => (
                <tr key={emp.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selected.includes(emp.id)}
                      onChange={() => toggleSelect(emp.id)}
                    />
                  </td>
                  <td>{emp.id}</td>
                  <td>{emp.name}</td>
                  <td>{emp.job}</td>
                  <td>{emp.status}</td>
                  <td className="action-cell">
                    <button
                      className="edit-btn"
                      onClick={() => editEmployee(emp)}
                    >
                      <b>Edit</b>
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => deleteOne(emp.id)}
                    >
                      <b>Delete</b>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No employees found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ===== PAGINATION ===== */}
      <div className="pagination">
        <button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          &lt;
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map(
          (pageNumber) => {
            if (
              pageNumber === 1 ||
              pageNumber === totalPages ||
              Math.abs(pageNumber - page) <= 1
            ) {
              return (
                <button
                  key={pageNumber}
                  className={pageNumber === page ? "active" : ""}
                  onClick={() => setPage(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            } else if (Math.abs(pageNumber - page) === 2) {
              return <span key={pageNumber}>...</span>;
            } else {
              return null;
            }
          },
        )}

        <button
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page === totalPages}
        >
          &gt;
        </button>
      </div>
    
        </div>
      </main>
     </div>
  );
}
